export default {
  UserLogin: 'userLogin',
  RegisterDevice: 'registerDevice',
  JoinClass: 'joinClass',
  JoinClassNoInvite: 'joinClassNoInvite',
  Trial: 'trial',
  ThirdPartyUser: 'thirdPartyUser',
  ClassShortCode: 'classShortCode',
}
